import { useBack } from 'admin';
import { MaterialProductValueType } from 'api';
import { Form, type InferType, useForm, yupResolver } from 'form';
import { Button, Page, Section } from 'ui';
import { AddBoxOutlined } from 'ui/icons';

import { MaterialProductFormSections } from '../../components/MaterialProductFormSections/MaterialProductFormSections';
import { useCreateMaterialProduct } from '../../hooks/useCreateMaterialProduct/useCreateMaterialProduct';
import { MaterialProductSchema } from '../schema';

export type CreateFormValues = InferType<typeof MaterialProductSchema>;

const DEFAULT_VALUES: Partial<CreateFormValues> = {
  buyer_material_component_values: [],
  material_colour_id: undefined,
  material_id: undefined,
  seller_material_component_values: [],
};

export const MaterialProductCreate = () => {
  const goBack = useBack();
  const form = useForm<CreateFormValues>({
    defaultValues: DEFAULT_VALUES,
    resolver: yupResolver(MaterialProductSchema),
  });

  const { mutate: createMaterialProduct, isPending } = useCreateMaterialProduct(form);

  const onSubmit = async (values: CreateFormValues) => {
    const sellerMaterialComponents = values.seller_material_component_values
      ? values.seller_material_component_values.map((materialComponent) => ({
          boolean_value: materialComponent.boolean_value,
          max_value: materialComponent.max_value ? materialComponent.max_value.toString() : undefined,
          min_value: materialComponent.min_value ? materialComponent.min_value.toString() : undefined,
          supported_component_id: materialComponent.supported_component_id,
          type: MaterialProductValueType.SELLER,
        }))
      : [];
    const buyerMaterialComponents = values.buyer_material_component_values
      ? values.buyer_material_component_values.map((materialComponent) => ({
          boolean_value: materialComponent.boolean_value,
          max_value: materialComponent.max_value ? materialComponent.max_value.toString() : undefined,
          min_value: materialComponent.min_value ? materialComponent.min_value.toString() : undefined,
          supported_component_id: materialComponent.supported_component_id,
          type: MaterialProductValueType.BUYER,
        }))
      : [];

    await createMaterialProduct({
      data: { ...values, material_component_values: [...sellerMaterialComponents, ...buyerMaterialComponents] },
    });
  };

  return (
    <Page>
      <Section title="Material Product" icon={AddBoxOutlined}>
        <Form {...form} onSubmit={onSubmit}>
          <MaterialProductFormSections />
          <Button loading={isPending} type="submit">
            Save
          </Button>
          <Button onClick={goBack} variant="secondary">
            Cancel
          </Button>
        </Form>
      </Section>
    </Page>
  );
};
